export default Object.freeze({
	SENTINEL_HANDSHAKE_ACK: 'szn.discussion.from.embed.sentinelHandshakeAck',
	RESIZE: 'szn.discussion.from.embed.resize',
	LINK_REDIRECT: 'szn.discussion.from.embed.redirect',
	CONTENT_CHANGED: 'szn.discussion.from.embed.pageChanged',
	SCROLL: 'szn.discussion.from.embed.scroll',
	ERROR: 'szn.discussion.from.embed.error',
	LOGIN: 'szn.discussion.from.embed.login',
	CONFIRM: 'szn.discussion.from.embed.confirm',
	COOKIE_FIX: 'szn.discussion.from.embed.cookieFix'
});
